@if (availablePoints().length) {
  <div class="flex flex-row-reverse">
    <mat-slide-toggle
      class="main-toggle"
      (change)="showSelectedOnly.set($event.checked)"
      [checked]="showSelectedOnly()"
      [ngClass]="toggleCssClass()"
      labelPosition="before"
    >
      Show selected
    </mat-slide-toggle>
  </div>
  <div class="mb-5">
    <app-search-input
      (searchDataEvent)="search.set($event)"
      [placeholder]="isRealtime() ? 'Search data point' : 'Search device attribute'"
      inputWidth="100%"
    />
  </div>
  <div class="flex flex-row">
    <ul class="grid grid-cols-3 overflow-y-auto max-h-[235px] w-full">
      @for (point of pointsToRender(); track point.name) {
        <li class="mb-2">
          <mat-checkbox
            class="max-w-full"
            (ngModelChange)="onSelectionChange(point, $event)"
            [(ngModel)]="point.checked"
          >
            <div class="font-semibold">
              {{ point.name }}
            </div>
            @if (isRealtime() && point.measurementUnit?.displayShort; as measurement) {
              <span class="text-ui-gray-100 text-xs">
                {{ measurement }}
              </span>
            }
          </mat-checkbox>
        </li>
      } @empty {
        <avs-no-data-placeholder
          class="col-span-3"
          [resultContent]="true"
        />
      }
    </ul>
  </div>
} @else {
  <avs-no-data-placeholder noDataText="No datapoints yet" />
}
